import React from 'react';
import Spinner from 'react-bootstrap/Spinner'

const SpinnerBox = (props) => {
  const spinnerStyle={
    width: `${props.width}`,
    height: `${props.height}px`,
    display: "flex",
    alignItems:"center", justifyContent: "center"
  }

  return(
    <div className="spinner-box" style={spinnerStyle}>
      <Spinner animation="border" variant="secondary" />
    </div>
  )
}

export default SpinnerBox;